import moment from 'moment';

export default {
    types: [
        'Water',
        'CO2',
        'Powder',
        'Foam',
    ],

    showExpiryNote: function (item, products) {
        if (!item || !item.product_id) {
            return false;
        }

        const product = products.find(p => p.id == item.product_id);
        if (!product || !product.name || product.name.toLowerCase() !== 'co2') {
            return false;
        }


        if (!item.ltd_month || !item.ltd) {
            return false;
        }
        const ltdDate = moment().year(item.ltd).month(item.ltd_month);

        return moment().subtract(9, 'years').isAfter(ltdDate);
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/include/FireEx.js